import fetchStatusReducerCreator from './'

export default fetchStatusReducerCreator({
  containerNesting: ['byUserId'],
})
